import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const responseParser = (response: any) => {
  return response
}

const getAllBankDetailsByIFSC = (ifscCode: string, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.getAllBankDetailsByIFSC,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: { ifscCode: ifscCode },
  }
  return executeRequest(request)
    .then((data) => {
      return responseParser(data.data)
    })
    .catch((error) => {
      throw error
    })
}

export { getAllBankDetailsByIFSC }
